import React from 'react';
import { useSuggestResultQueryState } from 'store/api/activitiesApi';
import { useSelector } from 'react-redux';
import { getSuggestions, SuggestionSearchResponse } from 'component/common/TextSearch/suggestionUtils';
import { selectConfigFromBootstrap, selectLocaleFromBootstrap } from 'store/slice/bootstrap';
import { selectPageTypeId } from 'store/slice/navigation';
import { isQueryLoading } from 'store/api/apiUtils';

export const useSuggestions = (searchText: string) => {
    const config = useSelector(selectConfigFromBootstrap);
    const pageTypeId = useSelector(selectPageTypeId);
    const locale = useSelector(selectLocaleFromBootstrap);
    const suggestionResponse = useSuggestResultQueryState(searchText);
    const areSuggestionsLoading = isQueryLoading(suggestionResponse);
    const suggestions = React.useMemo(() => {
        return getSuggestions(suggestionResponse as unknown as SuggestionSearchResponse, searchText.toLowerCase(), locale, pageTypeId, config);
    }, [suggestionResponse, searchText, locale, pageTypeId, config]);
    const hasSuggestions = suggestions && suggestions.length > 0;

    return { suggestions, areSuggestionsLoading, hasSuggestions };
};
